"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemMixin = void 0;
var _listItemResetMixin = require("../listItemResetMixin");
var _spacingMixin = require("../spacingMixin");
/** @class ListItemMixin */
/** @method */
var ListItemMixin = function ListItemMixin(props) {
  return [(0, _listItemResetMixin.listItemResetMixin)(props), (0, _spacingMixin.spacingMixin)(props)];
};
exports.ListItemMixin = ListItemMixin;